import type { FileType } from './extractStudents';

export type SelectableFileType = Extract<
  FileType,
  'wida_access' | 'alternate_access_wida' | 'student_roster'
>;

export const FILE_TYPE_OPTIONS: ReadonlyArray<{ value: SelectableFileType; label: string }> = [
  { value: 'wida_access', label: 'WIDA ACCESS Scores' },
  { value: 'alternate_access_wida', label: 'WIDA Alternate ACCESS Scores' },
  { value: 'student_roster', label: 'Student Roster (SIS)' },
];
